import { render, staticRenderFns } from "./BirthdayTemplateEdit.vue?vue&type=template&id=ad3253f0&scoped=true&"
import script from "./BirthdayTemplateEdit.vue?vue&type=script&lang=js&"
export * from "./BirthdayTemplateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BirthdayTemplateEdit.vue?vue&type=style&index=0&id=ad3253f0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3253f0",
  null
  
)

export default component.exports